<template>
  <qx-card title="列表">
    <PrePayDialog ref="prePayDialog" @sub="getData"/>
    <CarPrepayMoneyDialog ref="carPrepayMoneyDialog" @sub="getData"/>
    <DriverBasealaryDialog ref="driverBasealaryDialog" @sub="getData"/>
    <CoDriverBaseSalaryDialog ref="coDriverBaseSalaryDialog" @sub="getData"/>
    <!-- <FreightOfOrderDialog ref="freightOfOrderDialog" @sub="getData"/> -->
    <PayDialog ref="payDialog" @sub="getData"/>
    <CalibrationTimeDialog ref="calibrationTimeDialog" @sub="getData"/>
    <RemarkDialog ref="remarkDialog" @sub="getData"/>
    <BillDialog ref="billDialog" @sub="getData"/>
    <ContractDialog ref="contractDialog" @sub="getData"/>
    <CarDetailDialog ref="carDetailDialog"/>
    <section slot="titleRight">
      <qx-permpisions permpisions="3001905">
        <el-button type="primary" plain @click="changePayStatus"
        >修改预付状态
        </el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1001010104">
        <el-button type="primary" plain @click="() => setOrderStatus()"  :disabled="orderStatus"
        >已到达
        </el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1001010105">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="orderBO.ajax?cmd=getOrderList"
            :params="fullSearchData"
            bizName="客户订单数据导出"
            bizCode="exp202204"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
<!--      表格设置-->
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
           <el-table-column type="selection" width="55" :selectable="judgeSelect"/>
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
                :fixed="item.fixed"
                align="center"
                v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span v-if="scope.row.orderType === 1">固定：</span>
                  <span v-else-if="scope.row.orderType === 2">
                    <span v-if="scope.row.sourceFlag === 14">城配：</span>
                    <span v-else>临时：</span>
                  </span>
                  <span v-else>三方：</span>
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 运输线路 因导出时，页面数据和导出文件数据不一致，运输线路和货物信息改用后端拼接好的字段-->
<!--                <section-->
<!--                    v-else-if="scope.column.property === 'sourceRegionName'"-->
<!--                >-->
<!--                  <span-->
<!--                      :class="{-->
<!--                      primary: scope.row.sourceId !== -1 && scope.row.sourceId !==null,-->
<!--                      cur: scope.row.sourceId !== -1 && scope.row.sourceId !==null,-->
<!--                    }"-->
<!--                      @click="toLineDetail(scope.row)"-->
<!--                  >-->
<!--                    {{-->
<!--                      `${scope.row.sourceRegionName.replace(-->
<!--                          '市',-->
<!--                          ''-->
<!--                      )}-${scope.row.desRegionName.replace('市', '')}`-->
<!--                    }}-->
<!--                  </span>-->
<!--                </section>-->
                <!-- 运输线路 end -->
                <!-- 其他信息 -->
                <section v-else-if="scope.column.property === 'remark'" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                  <el-popover placement="top-start" width="120" trigger="hover">
                    <div >
                      <p>{{ scope.row[scope.column.property]}}</p>
                    </div>
                    <span class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>
                  </el-popover>
                </section>
                <!-- 其他信息 end -->
                <!-- 订单收入 -->
                <section v-else-if="scope.column.property === 'costPrice'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 订单收入 end -->
                <!-- 车牌号码 -->
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <el-popover placement="top" width="120" trigger="hover">
                    <div style="text-align: left">
                      <p>司机：{{ scope.row.carDriverMan }}</p>
                      <p>手机：{{ scope.row.carDriverPhone }}</p>
                      <p>车型：{{ scope.row.vehicleClassName }}</p>
                    </div>
                    <span class="primary cur" slot="reference">{{
                        scope.row[scope.column.property]
                      }}</span>
                  </el-popover>
                </section>
                <!-- 车牌号码 end -->
                <!-- 车辆类型 -->
                <section v-else-if="scope.column.property === 'licenceType'">
                  <span v-if="scope.row.licenceType === 2">{{
                      scope.row[scope.column.property]
                    }}</span>
                  <span v-else
                  >{{ scope.row.carLenghName }} /
                    {{ scope.row.carStatusName }}</span
                  >
                </section>
                <!-- 车辆类型 end -->
                <!-- 货物信息 注释原因同上方“运输线路”-->
<!--                <section v-else-if="scope.column.property === 'goodsName'">-->
<!--                  {{ scope.row.goodsName }}-->
<!--                  \-->
<!--                  {{ scope.row.weight ? scope.row.weight + '吨' : '' }}-->
<!--                  \-->
<!--                  {{ scope.row.square ? scope.row.square + '立方' : '' }}-->
<!--                </section>-->
                <!-- 货物信息 end -->
                <!-- 预付款 -->
                <section v-else-if="scope.column.property === 'preAmountFlag'">
                  <span v-if="scope.row.preAmountFlag === 1 && scope.row.paymentWayName!=='订单模式'">
                    <span>
                      {{
                        (scope.row.paymentWay === 1
                                ? (scope.row.estFee !== null ? scope.row.estFee : 0) /
                                100
                                : (scope.row.preTotalFee !== null
                                ? scope.row.preTotalFee
                                : 0) / 100
                        ).toFixed(2)
                      }}
                    </span>
                  </span>
                  <template
                      v-else-if="
                      scope.row.preAmountFlag !== 1 &&
                      scope.row.isPreAuditJurisdiction &&
                      scope.row.orderState >= 7 &&
                      scope.row.orderState < 15 &&
                      scope.row.isPreFinallyNode &&
                      scope.row.paymentWayName!=='订单模式'
                    "
                  >
                    <template v-if="checkPermpisions('3300192')">
                      <span
                          @click="showPayDialog(scope.row)"
                          class="primary cur"
                      >支付</span
                      >
                    </template>
                  </template>
                  <span
                      v-else-if="
                      scope.row.preAmountFlag !== 1 &&
                      scope.row.isPreAuditJurisdiction &&
                      scope.row.orderState >= 7 &&
                      scope.row.orderState < 15 &&
                      !scope.row.isPreFinallyNode &&
                      scope.row.paymentWayName!=='订单模式'
                    "
                      @click="showPayDialog(scope.row)"
                      class="primary cur"
                  >审核</span
                  >
                  <span
                      v-else-if="
                      scope.row.preAmountFlag !== 1 &&
                      !scope.row.isPreAuditJurisdiction &&
                      scope.row.orderState < 15 &&
                      scope.row.orderState > 7 &&
                      scope.row.paymentWayName!=='订单模式'
                    "
                  >未支付</span
                  >
                  <span v-else>--</span>
                </section>
                <!-- 预付款 end -->
                <!-- 到付款 -->
                <section
                    v-else-if="scope.column.property === 'arrivePaymentState'"
                >
                  <span v-if="scope.row.arrivePaymentState === 1">
                    {{
                      (
                          (scope.row.arrivePaymentFee !== null
                              ? scope.row.arrivePaymentFee
                              : 0) / 100
                      ).toFixed(2)
                    }}
                  </span>
                  <template
                      v-else-if="
                      scope.row.arrivePaymentState !== 1 &&
                      scope.row.isArriveAuditJurisdiction &&
                      scope.row.isArriveFinallyNode &&
                      scope.row.orderState >= 7 &&
                      scope.row.orderState < 15 &&
                      scope.row.arrivePaymentFee > 0
                    ">
                    <template v-if="checkPermpisions('3001902')">
                    <span
                        @click="showPayNowDialog(scope.row)"
                        class="primary cur"
                    >支付</span
                    >
                    </template>
                  </template>
                  <span
                      class="primary cur"
                      v-else-if="
                      scope.row.arrivePaymentState !== 1 &&
                      scope.row.isArriveAuditJurisdiction &&
                      !scope.row.isArriveFinallyNode &&
                      scope.row.orderState >= 7 &&
                      scope.row.orderState < 15 &&
                      scope.row.arrivePaymentFee > 0
                    "
                      @click="showPayNowDialog(scope.row)"
                  >审核</span
                  >
                  <span
                      v-else-if="
                      scope.row.arrivePaymentState !== 1 &&
                      !scope.row.isArriveAuditJurisdiction &&
                      scope.row.orderState < 15 &&
                      scope.row.orderState >= 7 &&
                      scope.row.arrivePaymentFee > 0
                    "
                  >未支付</span
                  >
                  <span v-else>--</span>
                </section>
                <!-- 到付款 end -->
                <!-- 合同 -->
                <section v-else-if="scope.column.property === 'contractUrl'">
                  <template v-if="checkPermpisions('1001010101')">
                    <span
                        class="primary cur"
                        @click="showContractDialog(scope.row)"
                    >{{ scope.row.loadState === 1 || scope.row.loadState === 4? '上传' : '查看' }}</span
                    >
                  </template>
                </section>
                <!-- 合同 end -->
                <!-- 回单 -->
                <section v-else-if="scope.column.property === 'reciveTypeName'">
                  {{ scope.row.reciveTypeName || '电子回单' }}:
                  <template v-if="checkPermpisions('1001010102')">
                    <span class="primary cur" @click="showBillDialog(scope.row)">
                      {{
                        scope.row.reciveState === 1 || scope.row.reciveState === 4
                            ? '上传'
                            : '查看'
                      }}
                    </span>
                  </template>
                </section>
                <!-- 回单 end -->
                <!-- 异常管理 -->
                <section v-else-if="scope.column.property === 'exceptionCount'">
                  <span
                      v-if="scope.row.exceptionCount"
                      class="primary cur"
                      @click="toOrderUnusualRegistration(scope.row, '5')"
                  >{{ scope.row.exceptionCount }}个</span
                  >
                  <template v-if="checkPermpisions('3300191')">
                    <span
                        v-if="
                        scope.row.orderState >= 7 &&
                        (scope.row.orderState < 14 || scope.row.isAddProblem)
                      "
                        class="primary cur"
                        style="margin-left: 8px"
                        @click="toAddNewUnusual(scope.row)"
                    >添加</span
                    >
                  </template>
                  <span
                      v-if="
                      !(
                        scope.row.orderState >= 7 &&
                        (scope.row.orderState < 14 || scope.row.isAddProblem)
                      ) && scope.row.exceptionCount <= 0
                    "
                  >--</span
                  >
                </section>
                <!-- 异常管理 end -->
                <!-- 时效罚款 -->
                <section v-else-if="scope.column.property === 'agingCount'">
                  <span
                      v-if="
                      scope.row.orderState >= 7 &&
                      scope.row.orderState <= 14 &&
                      scope.row.agingCount
                    "
                      class="primary cur"
                      @click="toOrderDetail(scope.row, '7')"
                  >{{ scope.row.agingCount }}个</span
                  >
                  <template v-if="checkPermpisions('3300214')">
                    <span
                        v-if="
                        scope.row.orderState >= 7 && scope.row.orderState < 13
                      "
                        class="primary cur"
                        style="margin-left: 8px"
                        @click="toAddCarrierLimitation(scope.row)"
                    >添加</span
                    >
                  </template>
                  <span
                      v-if="
                      !(scope.row.orderState >= 7 && scope.row.orderState <= 14)
                    "
                  >--</span
                  >
                </section>
                <!-- 时效罚款 end -->
                <!-- 运费 -->
                <section v-else-if="scope.column.property === 'totalFee'">
                  <span>{{ (scope.row.totalFee / 100).toFixed(2) }}</span>
                </section>
                <!-- 运费 end -->
                <!-- 费用上报 -->
                <section
                    v-else-if="scope.column.property === 'costReportStateName'"
                >
                  <span
                      v-if="
                      scope.row.paymentWay === 2 &&
                      scope.row.orderState >= 7 &&
                      scope.row.orderState < 14
                    "
                  >
                    {{ scope.row.costReportStateName }}
                    <span
                        v-if="checkPermpisions('3303225')"
                        class="primary cur"
                        @click="reportCost(scope.row)"
                    >上报</span
                    >
                  </span>
                  <span v-else>--</span>
                </section>
                <!-- 费用上报 end -->
                <!-- 订单状态 -->
                <section v-else-if="scope.column.property === 'orderStateName'">
                  {{ scope.row.orderStateName }}
                  <template v-if="checkPermpisions('3300196')">
                    <span
                        v-if="scope.row.trackType === 1"
                        class="primary cur"
                        @click="carPosStatusChange(scope.row, 1)"
                    >靠台</span
                    >
                  </template>
                  <template v-if="checkPermpisions('3300197')">
                    <span
                        v-if="scope.row.trackType === 2"
                        class="primary cur"
                        @click="carPosStatusChange(scope.row, 2)"
                    >离台</span
                    >
                  </template>
                  <template v-if="checkPermpisions('3300198')">
                    <span
                        v-if="scope.row.trackType === 3"
                        class="primary cur"
                        @click="carPosStatusChange(scope.row, 3)"
                    >到达</span
                    >
                  </template>
                  <template v-if="checkPermpisions('3300199')">
                    <span
                        v-if="scope.row.trackType === 4"
                        class="primary cur"
                        @click="carPosStatusChange(scope.row, 4)"
                    >离场</span
                    >
                  </template>
                </section>
                <!-- 订单状态 end -->
                <!-- 出车打款金额 -->
                <section v-else-if="scope.column.property === 'carPrepayMoneyDouble'">
                  <template v-if="Number(scope.row.paymentWay) === 4">
                    <el-popover placement="top" width="120" trigger="hover" v-if="scope.row.orderMoneyTypeList !== null">
                      <div style="text-align: left" v-for="(item,index) in scope.row.orderMoneyTypeList" :key="index">
                        <p>{{ item.moneyTypeName }}：{{ item.moneyTypeValueDouble }} 元</p>
                      </div>
                      <span :class="!(
                      scope.row.orderState >= 14 ||
                      (scope.row.fromOrderId &&
                        scope.row.fromOrderId > 0 &&
                        scope.row.toTenantId)
                    ) && !scope.row.isFinish && scope.row.sourceId!==null?'primary cur':''" slot="reference" @click="showCarPrepayMoneyDialog(scope.row)">{{
                          scope.row[scope.column.property]
                        }}</span>
                    </el-popover>
                    <span v-else>{{
                        scope.row[scope.column.property]
                      }}</span>
                  </template>
                  <span v-else>--</span>
                </section>
                <!-- 出车打款金额 end -->
                <!--本趟总服务费-->
                <!-- <section v-else-if="scope.column.property === 'freightOfOrderStr'">
                  <template v-if="Number(scope.row.paymentWay) === 4">
                    <span :class="!(
                      scope.row.orderState >= 14 ||
                      (scope.row.fromOrderId &&
                        scope.row.fromOrderId > 0 &&
                        scope.row.toTenantId)
                    ) && !scope.row.isFinish && scope.row.sourceId!==null?'primary cur':''"  @click="showFreightOfOrderDialog(scope.row)">
                      {{ scope.row.freightOfOrderStr }}
                    </span>

                  </template>
                  <span v-else>--</span>
                </section> -->
                <!--本趟总服务费end-->
                <!--副驾姓名-->
                <section v-else-if="scope.column.property === 'copilotMan'">
                    <span>{{ scope.row[scope.column.property] ? scope.row[scope.column.property]:'--'}}
                    </span>
                </section>
                <!--副驾姓名end-->
                <!--主驾基本工资-->
                <section v-else-if="scope.column.property === 'driverBasealaryDouble'">
                  <template v-if="Number(scope.row.paymentWay) === 4">
                    <span :class="!(
                      scope.row.orderState >= 14 ||
                      (scope.row.fromOrderId &&
                        scope.row.fromOrderId > 0 &&
                        scope.row.toTenantId)
                    ) && !scope.row.isFinish && scope.row.sourceId!==null?'primary cur':''"  @click="showDriverBasealaryDialog(scope.row)">
                      {{ scope.row.driverBasealaryDouble }}
                    </span>

                  </template>
                  <span v-else>--</span>
                </section>
                <!--主驾基本工资end-->
                <!--副驾基本工资-->
                <section v-else-if="scope.column.property === 'coDriverBaseSalaryDouble'">
                  <template v-if="Number(scope.row.paymentWay) === 4 && Number(scope.row.copilotUserId) > 0 && scope.row.coDriverBaseSalaryDouble!==null">
                    <span :class="!(
                      scope.row.orderState >= 14 ||
                      (scope.row.fromOrderId &&
                        scope.row.fromOrderId > 0 &&
                        scope.row.toTenantId)
                    ) && !scope.row.isFinish && scope.row.sourceId!==null?'primary cur':''"  @click="showCoDriverBaseSalaryDialog(scope.row)">
                      {{ scope.row.coDriverBaseSalaryDouble}}
                    </span>

                  </template>
                  <span v-else>--</span>
                </section>
                <!--副驾基本工资end-->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="170"
              fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isShowDropdown="true"
                  :isCenter="true"
                  :btnList="[
                  {
                    permpisions: '1001010103',
                    showCondition: scope.row.isVerity,
                    // showCondition:true,
                    name: '审核/上传',
                    event: () => toOrderDetail(scope.row,'','',1),
                  },
                  {
                    permpisions: '3300194',
                    showCondition: !(
                      scope.row.orderState >= 14 ||
                      (scope.row.fromOrderId &&
                        scope.row.fromOrderId > 0 &&
                        scope.row.toTenantId)
                    ) && !scope.row.isFinish && scope.row.sourceId!==null
                      && !scope.row.isLockTheOrder,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                  {
                    permpisions: '3303228',
                    showCondition: scope.row.orderState < 7,
                    name: '取消',
                    event: () => toCancel(scope.row),
                  },
                  {
                    permpisions: '3001901',
                    showCondition:
                      scope.row.isCalibration !== null &&
                      scope.row.isCalibration,
                    name: '校准时效',
                    style: { color: '#E95114' },
                    event: () => showCalibrationTimeDialog(scope.row),
                  },
                  {
                    permpisions: '3001901',
                    showCondition:
                      scope.row.isCalibration === null ||
                      !scope.row.isCalibration,
                    name: '校准时效',
                    event: () => showCalibrationTimeDialog(scope.row),
                  },
                  {
                    // permpisions: '3303227',
                    showCondition:
                      scope.row.vehicleClass === 1 &&
                      scope.row.preAmountFlag === 1 &&
                      scope.row.isPayDriverSubsidy,
                    name: '支付补贴',
                    event: () => toPayDriverSubsidy(scope.row),
                  },
                  // {
                  //   permpisions: '3303226',
                  //   showCondition:
                  //     scope.row.vehicleClass === 1 &&
                  //     scope.row.orderState >= 7 &&
                  //     scope.row.orderState < 14,
                  //   name: '切换司机',
                  //   event: () => toOrderDetail(scope.row, '7', 'driver'),
                  // },
                  {
                    permpisions: '3300201',
                    showCondition:
                      scope.row.fromOrderId === null ||
                      scope.row.fromOrderId === '' ||
                      scope.row.fromOrderId <= 0 && scope.row.sourceId!==null,
                    name: '复制',
                    event: () => toEdit(scope.row, 'copy'),
                  },
                  {
                    showCondition:
                      scope.row.orderState >= 7 && scope.row.orderState < 15,
                    name: '轨迹',
                    event: () => toTrack(scope.row),
                  },
                  {
                    name: '备注',
                    event: () => showRemarkDialog(scope.row),
                  },
                  {
                    permpisions: '1001010106',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemoveOrder(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import CarDetailDialog from 'components/carDetailDialog';
import ContractDialog from '../contractDialog';
import BillDialog from '../billDialog/billDialog';
import CalibrationTimeDialog from './calibrationTimeDialog/calibrationTimeDialog';
import RemarkDialog from '../remarkDialog';
import PrePayDialog from './prePayDialog';
import PayDialog from './payDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import CarPrepayMoneyDialog from './carPrepayMoneyDialog';
import DriverBasealaryDialog from './driverBasealaryDialog';
import CoDriverBaseSalaryDialog from './coDriverBaseSalaryDialog';
// import FreightOfOrderDialog from './freightOfOrderDialog';
import {
  orderList,
  orderChangePayStatus,
  getPreFeeZeroCount,
  departureOrders,
  optDepend, // 靠台
  optLeaveSes, // 离台
  optArrive, // 到达
  optLeaveDes, // 离场
  cancleOrder,
  getDriverSubsidy, // 支付补贴司机列表
  paySubsidy,
} from 'api/operate';
import {removeOrderInfo} from 'api/archives';

export default {
  mixins: [
    tableMixin,
  ],
  components: {
    CarDetailDialog,
    ContractDialog, // 合同
    BillDialog, // 单据
    CalibrationTimeDialog, // 校准时效
    RemarkDialog, // 备注
    PrePayDialog, // 支付预付卡
    PayDialog, // 支付到付款
    TableBtn, // 操作按钮
    ExportBtn, // 导出按钮
    TableSetting, // 表格设置
    CarPrepayMoneyDialog, // 出车费用打款
    DriverBasealaryDialog, // 主驾基本工资
    CoDriverBaseSalaryDialog, // 副驾基本工资
    // FreightOfOrderDialog//本趟总服务费
  },
  data () {
    return {
      downloadParams: {
        excelKeys: 'orderId,orgIdName,customName,customNumber,tenantName,remark,sourceName,' +
            'plateNumber,vehicleClassName,goodsInfo,nums,goodsTypeName,dependTime,createDate,' +
            'paymentWayName,totalFee,preTotalFeeDouble,arrivePaymentFeeDouble,acceptDate,orderStateName',
        excelLables: '订单号码,归属部门,客户名称,客户单号,承运方,其他信息,线路名称,车辆信息,车牌种类,货物信息,件数,货物类型,发车时间,创建时间,' +
            '成本模式,运费(元),预付款(元),到付款(元),接单时间,订单状态',
      },
      orderStatus: false,
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        title: [ // 表头
          {prop: 'orderId', label: '订单号码', w: 140, fixed: true},
          {prop: 'orgIdName', label: '归属部门'},
          {prop: 'customName', label: '客户名称'},
          {prop: 'customNumber', label: '客户单号'},
          {prop: 'tenantName', label: '承运方'},
          {prop: 'transportationRoute', label: '运输线路', w: 200},
          {prop: 'remark', label: '备注', w: 200},
          {prop: 'sourceName', label: '线路名称'},
          {prop: 'plateNumber', label: '车辆信息'},
          {prop: 'vehicleClassName', label: '车牌种类'},
          {prop: 'trailerNumber', label: '挂车牌号', show: false},
          {prop: 'trailerType', label: '挂车车型', show: false},
          {prop: 'goodsInfo', label: '货物信息', w: 160},
          {prop: 'nums', label: '件数'},
          {prop: 'goodsTypeName', label: '货物类型'},
          {prop: 'dependTimeStr', label: '发车时间'},
          {prop: 'createDate', label: '创建时间'},
          {prop: 'paymentWayName', label: '成本模式'},
          {prop: 'totalFee', label: '运费(元)'},
          {prop: 'preAmountFlag', label: '预付款(元)', noExport: true},
          {prop: 'arrivePaymentState', label: '到付款(元)', noExport: true},
          {prop: 'contractUrl', label: '合同', w: 80, noExport: true},
          {prop: 'reciveTypeName', label: '回单', w: 200, noExport: true},
          {prop: 'exceptionCount', label: '异常管理', noExport: true},
          {prop: 'agingCount', label: '时效罚款', noExport: true},
          {prop: 'costReportStateName', label: '费用上报', w: 140, noExport: true},
          {prop: 'acceptDate', label: '接单时间'},
          {prop: 'orderStateName', label: '订单状态'},
          // {prop: 'freightOfOrderStr', label: '本趟总服务费', show: false},
          {prop: 'carDriverMan', label: '主驾姓名', show: false},
          {prop: 'driverBasealaryDouble', label: '主驾基本服务费'},
          {prop: 'copilotMan', label: '副驾姓名'},
          {prop: 'coDriverBaseSalaryDouble', label: '副驾基本服务费'},
          {prop: 'carPrepayMoneyDouble', label: '出车打款金额'},
          {prop: 'priceUnit', label: '收入单价', show: false},
          {prop: 'drivingType', label: '单/双驾', show: false},
          {prop: 'moneyState', label: '费用数据状态', show: false},
          {prop: 'oilConsumptionState', label: '油耗数据状态', show: false},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  watch: {
    'tableData.title': function (val) {
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout();
        // console.log();
      });
    },
  },
  methods: {
    getList: orderList,
    toAddNewUnusual (item) {
      this.jump({
        label: '新增异常登记',
        url: `/manage/operate/order/deal/orderDetailTab/unusual/edit?orderId=${item.orderId}`,
      });
    },
    toAddCarrierLimitation (item) {
      this.jump({
        label: '新增时效罚款',
        url: `/manage/operate/order/deal/orderDetailTab/carrier/edit?orderId=${item.orderId}`,
      });
    },
    toOrderDetail (item, defaultActive = '', defaultChildActive = 'carrier', isVerity) {
      console.log(item.orderId);
      this.jump({
        label: `订单详情-${item.orderId}`,
        // label: `修改司机-${item.orderId}`,
        // url:`deal/orderDetailTab/driver/edit?id=${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&defaultActive=${defaultActive}&defaultChildActive=${defaultChildActive}&isVerity=${isVerity}`,
        full: true,
      });
    },
    async toRemoveOrder (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.orderId}】这个订单吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeOrderInfo({
          orderId: item.orderId,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
    toOrderUnusualRegistration (item) {
      this.jump({
        label: '异常登记',
        url: `/manage/operate/order/unusual/registration?id=${item.orderId}&showBaseInfo=1`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1 || item.sourceId === null) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showCarDetail (item) {
      this.$refs.carDetailDialog.show(item);
    },
    showCarPrepayMoneyDialog (item) {
      if ((!(item.orderState >= 14 || (item.fromOrderId && item.fromOrderId > 0 && item.toTenantId)) && !item.isFinish && item.sourceId !== null)) {
        this.$refs.carPrepayMoneyDialog.show(item);
      }

    },
    // showFreightOfOrderDialog(item){
    //   if(!(!(item.orderState >= 14 || (item.fromOrderId && item.fromOrderId > 0 && item.toTenantId)) && !item.isFinish && item.sourceId!==null)){
    //     return
    //   }else {
    //     this.$refs.freightOfOrderDialog.show(item);
    //   }
    // },
    showDriverBasealaryDialog (item) {
      if ((!(item.orderState >= 14 || (item.fromOrderId && item.fromOrderId > 0 && item.toTenantId)) && !item.isFinish && item.sourceId !== null)) {
        this.$refs.driverBasealaryDialog.show(item);
      }
    },
    showCoDriverBaseSalaryDialog (item) {
      if ((!(item.orderState >= 14 || (item.fromOrderId && item.fromOrderId > 0 && item.toTenantId)) && !item.isFinish && item.sourceId !== null)) {
        this.$refs.coDriverBaseSalaryDialog.show(item);
      }
    },
    async changePayStatus () {
      this.searchBoxData.outerFlg = 2;
      this.searchBoxData._ALLEXPORT = 1;
      const data = await getPreFeeZeroCount(this.searchBoxData);
      let confirmMsg = '';
      if (data <= 0) {
        confirmMsg = '没有找到预付款为 0 的订单。修改订单后没有审核完成的订单不包含在内';
      } else {
        confirmMsg = `确认将未支付预付款的订单（报账模式/承包模式）修改为已支付？订单数量为：${data}。修改订单后没有审核完成的订单不包含在内`;
      }
      const confirmRes = await this.$confirm(confirmMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await orderChangePayStatus(this.searchBoxData);
        if (!res.failed) {
          this.$message.success('修改成功');
          this.getData();
        }
      }
    },
    judgeSelect (row, index) {
      return row.orderStateName === '待装货' || row.orderStateName === '装货中' || row.orderStateName === '运输中' || row.orderStateName === '已到达';// 返回true该行可选，返回false则不可选
    },
    async setOrderStatus () { // 批量更改订单状态
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择订单');
      } else {
        await this.$confirm(`目前已选择${this.tableData.selectResult.length}条订单，确认所选订单已运输完成吗？`, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.orderStatus = true;
          const orderIds = this.tableData.selectResult.map((item) => item.orderId);
          const res = await departureOrders({
            orderIds: orderIds.join(','),
          });
          if (res && res.code === 202) {
            this.$message({
              type: 'error',
              message: res.msg,
            });
            this.tableData.selectResult.length = 0;
            await this.getData();
          } else {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.tableData.selectResult.length = 0;
            await this.getData();
          }
          this.orderStatus = false;
        }).catch(() => {
          // 取消操作
        });
      }
    },
    showContractDialog (item) {
      this.$refs.contractDialog.show(item);
    },
    showBillDialog (item) {
      this.$refs.billDialog.show(item);
    },
    async carPosStatusChange (item, tar) { // 车辆位置变更
      let fn;
      let label = '';
      if (tar === 1) {
        label = '靠台';
        fn = optDepend;
      } else if (tar === 2) {
        label = '离台';
        fn = optLeaveSes;
      } else if (tar === 3) {
        label = '到达';
        fn = optArrive;
      } else {
        label = '离场';
        fn = optLeaveDes;
      }
      const confirmRes = await this.$confirm(`确认${label}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消靠台
      });
      if (confirmRes === 'confirm') {
        const res = await fn({orderId: item.orderId});
        if (!res.failed) {
          this.$message.success(label + '成功');
          this.getData();
        }
      }
    },
    async toCancel (item) {
      const confirmRes = await this.$confirm(`确认取消${item.orderId}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消靠台
      });
      if (confirmRes === 'confirm') {
        const res = await cancleOrder({orderId: item.orderId});
        if (!res.failed) {
          this.$message.success('操作成功');
          this.getData();
        }
      }
    },
    toTrack (item) {
      this.jump({
        label: '查看轨迹',
        url: `/manage/operate/track/trackDetail?orderId=${item.orderId}`,
      });
    },
    reportCost (item) { // 费用上报
      this.jump({
        label: '费用上报',
        url: `/manage/operate/order/deal/reportCost?id=${item.orderId}&plateNumber=${encodeURIComponent(item.plateNumber)}`,
      });
    },
    showCalibrationTimeDialog (item) { // 校准时效
      this.$refs.calibrationTimeDialog.show(item);
    },
    showRemarkDialog (item) { // 备注
      this.$refs.remarkDialog.show(item);
    },
    async toPayDriverSubsidy (item) { // 支付补贴
      const params = {
        orderId: item.orderId,
      };
      // 查询需要支付补贴的司机列表
      const resSubsidy = await getDriverSubsidy(params);
      if (resSubsidy && resSubsidy.length) {
        const h = this.$createElement;
        const driverList = [];
        for (let item of resSubsidy) {
          driverList.push(h('p', null, `给 ${item.userName || '--'}（${item.userPhone || '--'}） 支付 ${(item.subsidy / 100).toFixed(2)} 元`));
        }
        const confirmRes = await this.$confirm(h('div', null, [
          h('div', null, [
            h('p', null, '确认给以下司机支付补贴吗？'),
            ...driverList,
          ]),
        ], '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })).catch(() => { // 取消操作
        });
        if (confirmRes === 'confirm') {
          const resPaySubsidy = await paySubsidy(params);
          if (!resPaySubsidy.failed) {
            if (resPaySubsidy && resPaySubsidy.msg && resPaySubsidy.msg === 'Y') {
              this.$message.success('操作成功');
              this.getData();
            }
          }
        }
      } else {
        this.$message.error('未找到订单相关司机需要支付补贴，请确认！');
      }
    },
    showPayDialog (item) { // 预付支付
      this.$refs.prePayDialog.show(item);
    },
    showApprovePayDialog (item) { // 预付审核
      console.log(item);
    },
    showPayNowDialog (item) { // 到付支付
      this.$refs.payDialog.show(item);
    },
    showApprovePayNowDialog (item) { // 到付审核
      console.log(item);
    },
    toEdit (item, type) { // 修改、复制
      let label = '';
      let url = '';
      if (type === 'edit') {
        label = `订单修改-${item.orderId}`;
        if (item.sourceFlag === 14) {
          // 城配订单
          url = `/manage/distribution/customerOrder/dispatch/edit?id=${item.orderId}`;
        } else {
          url = `/manage/operate/order/deal/edit?id=${item.orderId}`;
        }
      } else if (type === 'copy') {
        label = '订单复制';
        url = `/manage/operate/order/deal/edit?id=${item.orderId}&copy=1`;
      }
      this.jump({
        label,
        url,
        full: true,
      });
    },
    toCostApproveDetail (item) {
      this.jump({
        label: '上报费用详情',
        url: `/manage/cost/report/approve/detail?orderId=${item.orderId}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
